import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required!"),

  member_price: Yup.number()
    .typeError("Member price must be a number")
    .min(0, "Negative value not allowed")
    .required("Member price is required!"),

  non_member_price: Yup.number()
    .typeError("Non-member price must be a number")
    .min(0, "Negative value not allowed")
    .required("Non-member price is required!"),

  is_active: Yup.number().required("Status is required!"),
});
